<template>
  <div :class="$style.overlay">
    <form @submit.prevent="handleSubmit">
      <div :class="$style.reservationPopup">
        <b :class="$style.reservation">Reservation</b>
        <div :class="$style.frameParent">
          <div :class="$style.selectionContainer">
            <div :class="$style.leftLabel">Activity Type*</div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                :options="eventTypes"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.eventTypeId"
                @change="selectedActivity"
                :disabled="!!event || isMaintenance"
              ></hilo-select>
            </div>
          </div>
          <div :class="$style.selectionContainer">
            <div :class="$style.leftLabel">Event Start*</div>
            <div :class="$style.dateContainer">
              <div :class="$style.dateParent">
                <input
                  type="datetime-local"
                  v-model="formData.startDateTime"
                  required
                  :class="[
                    $style.datetimeInput,
                    { [$style['placeholder-active']]: !formData.startDateTime },
                  ]"
                />
              </div>
            </div>
          </div>
          <div :class="$style.selectionContainer">
            <div :class="$style.leftLabel">Event End*</div>
            <div :class="$style.dateContainer">
              <div :class="$style.dateParent">
                <input
                  type="datetime-local"
                  v-model="formData.endDateTime"
                  required
                  :class="[
                    $style.datetimeInput,
                    { [$style['placeholder-active']]: !formData.endDateTime },
                  ]"
                />
              </div>
            </div>
          </div>
          <div v-if="endDateIsBeforeStartDate" :class="$style.redError">
            The event end must be after the event start.
          </div>
          <div v-if="isPastEvent" :class="$style.orangeWarning">
            <input
              type="checkbox"
              id="past-confirm"
              v-model="formData.pastConfirm"
              required
            />
            I understand that the event start is in the past.
          </div>
          <div :class="$style.selectionContainer" v-if="showCustomer1">
            <div :class="$style.leftLabel">
              Customer 1<span v-if="customer1Required">*</span>
            </div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                id="customer1"
                :options="customers"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.customer1Id"
                :required="customer1Required"
              ></hilo-select>
            </div>
          </div>
          <div
            v-if="customerHasFlightHold(formData.customer1Id)"
            :class="$style.redError"
          >
            {{ customerFlightHoldMessage(formData.customer1Id) }}
          </div>
          <div :class="$style.selectionContainer" v-if="showCustomer2">
            <div :class="$style.leftLabel">
              Customer 2<span v-if="customer2Required">*</span>
            </div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                id="customer2"
                :options="customers"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.customer2Id"
                :required="customer2Required"
              ></hilo-select>
            </div>
          </div>
          <div
            v-if="customerHasFlightHold(formData.customer2Id)"
            :class="$style.redError"
          >
            {{ customerFlightHoldMessage(formData.customer2Id) }}
          </div>
          <div :class="$style.selectionContainer" v-if="showCustomer3">
            <div :class="$style.leftLabel">Customer 3</div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                id="customer3"
                :options="customers"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.customer3Id"
              ></hilo-select>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showCustomer4">
            <div :class="$style.leftLabel">Customer 4</div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                id="customer4"
                :options="customers"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.customer4Id"
              ></hilo-select>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showCustomer5">
            <div :class="$style.leftLabel">Customer 5</div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                id="customer5"
                :options="customers"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.customer5Id"
              ></hilo-select>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showDisplayName">
            <div :class="$style.leftLabel">Display Name</div>
            <div :class="$style.chooseOneParent">
              <input
                id="tempDisplayName"
                v-model="formData.tempDisplayName"
                type="text"
                placeholder="Display Name..."
                :class="$style.inputStyle"
              />
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showAircraft">
            <div :class="$style.leftLabel">
              Preferred Aircraft<span v-if="aircraftRequired">*</span>
            </div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                :options="aircraft"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.aircraftId"
                :required="aircraftRequired"
              ></hilo-select>
            </div>
          </div>
          <div v-if="planeMaintenance" :class="$style.redError">
            This aircraft is scheduled for maintenance during the selected time.
          </div>
          <div :class="$style.selectionContainer" v-if="showInstructor">
            <div :class="$style.leftLabel">
              Preferred Instructor<span v-if="instructorRequired">*</span>
            </div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                :options="instructors"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.instructorId"
                :required="instructorRequired"
              ></hilo-select>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showDpe">
            <div :class="$style.leftLabel">
              Preferred DPE<span v-if="dpeRequired">*</span>
            </div>
            <div :class="$style.chooseOneParent">
              <hilo-select
                :options="dpes"
                theme="grey"
                placeholder="Choose One"
                :searchable="true"
                :customStyle="{
                  height: '50px',
                  width: '100%',
                }"
                v-model="formData.dpeId"
                :required="dpeRequired"
              ></hilo-select>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showDayNightFlight">
            <div :class="$style.leftLabel">
              Day/Night Flight<span v-if="dayNightFlightRequired">*</span>
            </div>
            <div :class="$style.radioGroupParent">
              <RadioGroup
                v-model="formData.dayNightFlight"
                :required="dayNightFlightRequired"
              >
                <Radio value="Day" label="Day" />
                <Radio value="Night" label="Night" />
              </RadioGroup>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showFlightType">
            <div :class="$style.leftLabel">
              Flight Type<span v-if="flightTypeRequired">*</span>
            </div>
            <div :class="$style.radioGroupParent">
              <RadioGroup
                v-model="formData.flightType"
                :required="flightTypeRequired"
              >
                <Radio value="Cross Country" label="Cross Country" />
                <Radio value="Local" label="Local" />
              </RadioGroup>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showFlightRules">
            <div :class="$style.leftLabel">
              Flight Rules<span v-if="flightRulesRequired">*</span>
            </div>
            <div :class="$style.radioGroupParent">
              <RadioGroup
                v-model="formData.flightRules"
                :required="flightRulesRequired"
              >
                <Radio value="VFR" label="VFR" />
                <Radio value="IFR" label="IFR" />
              </RadioGroup>
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showFlightTime">
            <div :class="$style.leftLabel">
              Flight Time<span v-if="flightTimeRequired">*</span>
            </div>
            <div :class="$style.textAreaParent">
              <textarea
                v-model="formData.flightTime"
                maxlength="250"
                class="form-control"
              ></textarea>
              <span
                v-if="formData.flightTime && formData.flightTime.length"
                class="input-count"
                >{{ this.formData.flightTime.length }}/250</span
              >
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showFlightRoute">
            <div :class="$style.leftLabel">
              Flight Route<span v-if="flightRouteRequired">*</span>
            </div>
            <div :class="$style.textAreaParent">
              <textarea
                v-model="formData.flightRoute"
                maxlength="250"
                class="form-control"
              ></textarea>
              <span
                v-if="formData.flightRoute && formData.flightRoute.length"
                class="input-count"
                >{{ this.formData.flightRoute.length }}/250</span
              >
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showComments">
            <div :class="$style.leftLabel">Comments</div>
            <div :class="$style.textAreaParent">
              <textarea
                v-model="formData.comments"
                maxlength="250"
                class="form-control"
              ></textarea>
              <span
                v-if="formData.comments && formData.comments.length"
                class="input-count"
                >{{ this.formData.comments.length }}/250</span
              >
            </div>
          </div>
          <div :class="$style.selectionContainer" v-if="showInternalComments">
            <div :class="$style.leftLabel">Internal Comments</div>
            <div :class="$style.textAreaParent">
              <textarea
                v-model="formData.internalComments"
                maxlength="250"
                class="form-control"
              ></textarea>
              <span
                v-if="
                  formData.internalComments && formData.internalComments.length
                "
                class="input-count"
                >{{ this.formData.internalComments.length }}/250</span
              >
            </div>
          </div>
          <!--          V2 -->
          <!--          <div :class="$style.selectionContainer">-->
          <!--            <div :class="$style.leftLabel">Standby</div>-->
          <!--            <div :class="$style.switchContainer">-->
          <!--              <el-switch-->
          <!--                style="display: block"-->
          <!--                v-model="formData.standby"-->
          <!--                active-color="#00a551"-->
          <!--                inactive-color="#d54b4e"-->
          <!--              />-->
          <!--            </div>-->
          <!--          </div>-->
          <div v-if="isDoubleBooked" :class="$style.orangeWarning">
            <input
              type="checkbox"
              id="double-booked-confirm"
              v-model="formData.doubleBookedConfirm"
              required
            />
            I acknowledge that the following are double booked:<br /><br />
            {{ this.doubleBookedItems }}
          </div>
        </div>
        <button :class="$style.continueWrapper" type="submit">
          {{ isEditMode ? "Update" : "Continue" }}
        </button>
        <img
          @click="closeModal"
          :class="$style.vectorIcon9"
          alt=""
          src="/static/img/grey-x.svg"
        />
      </div>
    </form>
  </div>
</template>
<script>
// import { RadioGroup, Radio, Switch } from "element-ui";
import { RadioGroup, Radio } from "element-ui";
import { pullObjectInfo, generateChangelog } from "./scheduleUtils.js";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import AircraftAPIService from "../../../../servicehandlers/AircraftAPIService.js";
import ActiveInstructorsAPIService from "../../../../servicehandlers/ActiveInstructorsAPIService.js";
import DpeAPIService from "../../../../servicehandlers/DpeAPIService.js";
import ActiveStudentsAPIService from "../../../../servicehandlers/ActiveStudentsAPIService.js";
import UsersAPIService from "../../../../servicehandlers/UsersAPIService.js";
import EventsAPIService from "../../../../servicehandlers/EventsAPIService.js";
import EventRoomsAPIService from "../../../../servicehandlers/EventRoomsAPIService.js";
import EventTypesAPIService from "../../../../servicehandlers/EventTypesAPIService.js";
import { useLoginStore } from "@/stores/loginStore";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";

const aircraftAPIService = new AircraftAPIService();
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
const dpeAPIService = new DpeAPIService();
const activeStudentsAPIService = new ActiveStudentsAPIService();
const usersAPIService = new UsersAPIService();
const eventsAPIService = new EventsAPIService();
const eventRoomsAPIService = new EventRoomsAPIService();
const eventTypesAPIService = new EventTypesAPIService();

export default {
  components: {
    HiloSelect,
    RadioGroup,
    Radio,
    // ElSwitch: Switch,
  },
  props: {
    event: Object,
    isMaintenance: Boolean,
  },
  data() {
    return {
      aircraft: [],
      instructors: [],
      dpes: [],
      rooms: [],
      events: [],
      eventTypes: [],
      customers: [],
      users: [],
      currentUser: {},
      formFields: {
        eventTypeId: "",
        scheduledColor: "",
        startedColor: "",
        completedColor: "",
        textColor: "",
        tempDisplayName: "",
        startDateTime: "",
        endDateTime: "",
        pastConfirm: false,
        isRecurring: false,
        recurringInterval: "",
        customer1Id: null,
        customer2Id: null,
        customer3Id: null,
        customer4Id: null,
        customer5Id: null,
        aircraftId: null,
        planeConfirm: false,
        instructorId: null,
        dpeId: null,
        roomId: null,
        hostName: "",
        hostId: null,
        attendees: [],
        dayNightFlight: "",
        flightType: "",
        flightRules: "",
        flightRoute: "",
        flightTime: "",
        comments: "",
        internalComments: "",
        //notification stuff
        standby: false,
        doubleBookedConfirm: false,
      },
      formData: {
        ...this.formFields,
        startDateTime: "", // Weird issue where reactivity doesn't work unless the default value is set here (even though it's already coming in with the spread operator)
      },
      pastEvent: {
        ...this.formFields,
        history: "",
      },
      // showRecurring: true,
      showCustomer1: false,
      showCustomer2: false,
      showCustomer3: false,
      showCustomer4: false,
      showCustomer5: false,
      customer1Required: false,
      customer2Required: false,
      showDisplayName: false,
      displayNameRequired: false,
      showAircraft: false,
      aircraftRequired: false,
      showInstructor: false,
      instructorRequired: false,
      showDpe: false,
      dpeRequired: false,
      // showRoom: false,
      // roomRequired: false,
      // showHost: false,
      // hostRequired: false,
      // showAttendees: false,
      // attendeesRequired: false,
      showDayNightFlight: false,
      dayNightFlightRequired: false,
      showFlightType: false,
      flightTypeRequired: false,
      showFlightRules: false,
      flightRulesRequired: false,
      showFlightRoute: false,
      flightRouteRequired: false,
      showFlightTime: false,
      flightTimeRequired: false,
      showComments: true,
      expandComments: false,
      showInternalComments: true,
      expandInternalComments: false,
      // showNotifications: true,
      // expandNotifications: false,
      // showStandby: true,
      //need notification stuff
      isEditMode: false,
      doubleBookedItems: "",
      isDeleteEventModalVisible: false,
      deleteEventFooterButtons: [
        {
          label: "Cancel",
          type: "default",
          onClick: this.closeDeleteModal,
        },
        {
          label: "Confirm",
          type: "redTrashIcon",
          onClick: this.confirmDeleteEvent,
        },
      ],
    };
  },
  async mounted() {
    const user = useLoginStore().getUser;
    this.currentUser = {
      userId: user.id,
      userName: `${user.firstName} ${user.lastName}`,
    };
    await Promise.all([
      this.getEventTypes(),
      this.getAircraft(),
      this.getUsers(),
      this.getInstructors(),
      this.getDpes(),
      this.getCustomers(),
      this.getEvents(),
      this.getRooms(),
    ]);
    await this.getEvent();
    if (this.isMaintenance) {
      this.formData.eventTypeId = this.eventTypes.find(
        (eventType) => eventType.name === "Maintenance",
      ).id;
      this.selectedActivity();
      this.$forceUpdate();
    }
  },
  computed: {
    customerLabel() {
      const selectedType = this.eventTypes.find(
        (type) => type.id === this.formData.eventTypeId,
      );

      if (!selectedType) return "Customer";

      switch (selectedType.name) {
        case "Crew Flight":
        case "Renter/Member Flight":
        case "Ground Training":
          return "Customer 1";
        default:
          return "Customer";
      }
    },
    isPastEvent() {
      if (
        this.formData.startDateTime &&
        dayjs(this.formData.startDateTime).isValid()
      ) {
        const startTime = dayjs(this.formData.startDateTime).startOf("minute");
        const now = dayjs().startOf("minute");
        return startTime.isBefore(now);
      }
      return false;
    },
    endDateIsBeforeStartDate() {
      if (
        this.formData.startDateTime &&
        this.formData.endDateTime &&
        dayjs(this.formData.startDateTime).isValid() &&
        dayjs(this.formData.endDateTime).isValid()
      ) {
        return dayjs(this.formData.endDateTime).isBefore(
          dayjs(this.formData.startDateTime),
        );
      }
      return false;
    },
    isDoubleBooked() {
      if (!this.formData.startDateTime || !this.formData.endDateTime) {
        return false;
      }

      const maintenanceType = this.eventTypes.find(
        (type) => type.name === "Maintenance",
      );

      const maintenanceTypeId = maintenanceType ? maintenanceType.id : null;

      const entityChecks = [
        { id: this.formData.aircraftId, type: "aircraft", list: this.aircraft },
        {
          id: this.formData.instructorId,
          type: "instructor",
          list: this.instructors,
        },
        { id: this.formData.roomId, type: "room", list: this.rooms },
      ];

      let doubleBookedItems = [];

      entityChecks.forEach(({ id, type, list }) => {
        if (id) {
          const matchingEvents = this.events.filter((event) => {
            const eventStart = dayjs(event.startDateTime);
            const eventEnd = dayjs(event.endDateTime);
            const formStart = dayjs(this.formData.startDateTime);
            const formEnd = dayjs(this.formData.endDateTime);

            return (
              event[`${type}Id`] === id &&
              event.id !== this.formData.id &&
              event.eventTypeId !== maintenanceTypeId &&
              (eventStart.isBetween(formStart, formEnd, null, "[)") ||
                eventEnd.isBetween(formStart, formEnd, null, "(]"))
            );
          });

          matchingEvents.forEach(() => {
            doubleBookedItems.push(list.find((item) => item.id === id).name);
          });
        }
      });

      return doubleBookedItems.join(", ");
    },
    planeMaintenance() {
      if (
        this.formData.startDateTime &&
        this.formData.endDateTime &&
        this.formData.aircraftId
      ) {
        const maintenanceType = this.eventTypes.find(
          (type) => type.name === "Maintenance",
        );

        if (
          !maintenanceType ||
          this.formData.eventTypeId === maintenanceType.id
        )
          return false;

        const formStart = dayjs(this.formData.startDateTime).utc();
        const formEnd = dayjs(this.formData.endDateTime).utc();

        return this.events.some((event) => {
          if (
            event.eventTypeId === maintenanceType.id &&
            event.aircraftId === this.formData.aircraftId
          ) {
            const eventStart = dayjs.utc(event.startDateTime);
            const eventEnd = dayjs.utc(event.endDateTime);

            return (
              eventStart.isBetween(formStart, formEnd, null, "[)") ||
              eventEnd.isBetween(formStart, formEnd, null, "(]") ||
              (formStart.isBetween(eventStart, eventEnd, null, "[)") &&
                formEnd.isBetween(eventStart, eventEnd, null, "(]"))
            );
          }
          return false;
        });
      }
      return false;
    },
  },
  watch: {
    isDoubleBooked: {
      immediate: true, // This ensures the watcher runs on component mount
      handler(newVal) {
        this.doubleBookedItems = newVal;
      },
    },
  },
  methods: {
    async getEvent() {
      try {
        if (this.event) {
          let copy = this.event;

          const defaultDisplayName = `${dayjs(copy.startDateTime).format(
            "HH:mm",
          )} ${pullObjectInfo(this.customers, copy.customer1Id)?.name}`;
          copy.tempDisplayName =
            copy.displayName === defaultDisplayName ? "" : copy.displayName;

          copy.startDateTime = dayjs(copy.startDateTime).format(
            "YYYY-MM-DD HH:mm",
          ); // #DATE
          copy.endDateTime = dayjs(copy.endDateTime).format("YYYY-MM-DD HH:mm"); // #DATE
          this.isEditMode = true;
          this.pastEvent = { ...copy };
          this.formData = { ...copy }; // Populate formData with event data for editing
          this.$nextTick(() => {
            // Immediately expand form
            this.selectedActivity();
          });
        }
      } catch {
        //pass
      }
    },
    async getEventTypes() {
      try {
        this.eventTypes = await eventTypesAPIService.get(this.$router);
      } catch (error) {}
    },
    async getAircraft() {
      try {
        this.aircraft = await aircraftAPIService.get(this.$router);
        this.aircraft = this.aircraft.map((item) => ({
          ...item,
          name: `${item.tailNumber} ${item.model}`,
        }));
      } catch (error) {}
    },
    async getUsers() {
      try {
        this.users = await usersAPIService.get(this.$router);
      } catch (error) {}
    },
    async getInstructors() {
      try {
        this.instructors = await activeInstructorsAPIService.get(this.$router);
        this.instructors = this.instructors.map((instructor) => ({
          ...instructor,
          name: `${instructor.user.firstName} ${instructor.user.lastName}`,
        }));
      } catch (error) {}
    },
    async getDpes() {
      try {
        this.dpes = await dpeAPIService.get(this.$router);
        this.dpes = this.dpes.map((dpe) => ({
          ...dpe,
          name: `${dpe.user.firstName} ${dpe.user.lastName}`,
        }));
      } catch (error) {}
    },
    async getCustomers() {
      try {
        this.customers = await activeStudentsAPIService.get(this.$router);
        this.customers = this.customers.map((student) => ({
          ...student,
          name: `${student.user.firstName} ${student.user.lastName}`,
        }));
      } catch (error) {}
    },
    async getEvents() {
      try {
        this.events = await eventsAPIService.get(this.$router);
      } catch (error) {}
    },
    async getRooms() {
      try {
        this.rooms = await eventRoomsAPIService.get(this.$router);
      } catch (error) {}
    },
    customerHasFlightHold(customerId) {
      const customer = this.customers.find(
        (customer) => customer.id === customerId,
      );
      const hasFlightHold = customer && customer.flightHold === true;

      const eventType = this.eventTypes.find(
        (event) => event.id === this.formData.eventTypeId,
      );

      const isFlyingEventType =
        eventType &&
        (eventType.name.includes("Flight") ||
          eventType.name === "Student Solo");

      return hasFlightHold && isFlyingEventType;
    },
    customerFlightHoldMessage(customerId) {
      const customer = this.customers.find(
        (customer) => customer.id === customerId,
      );
      return customer
        ? `${customer.user.firstName} ${customer.user.lastName} currently has a flight hold. Flights cannot be booked until this is resolved.`
        : "Customer has a flight hold. Flights cannot be booked until this is resolved.";
    },
    resetFields() {
      this.customer1Required = false;
      this.customer2Required = false;
      this.aircraftRequired = false;
      this.instructorRequired = false;
      this.dpeRequired = false;
      // this.roomRequired = false;
      // this.hostRequired = false;
      // this.attendeesRequired = false;
      this.dayNightFlightRequired = false;
      this.flightTypeRequired = false;
      this.flightRulesRequired = false;
      this.flightRouteRequired = false;
      this.flightTimeRequired = false;

      this.showCustomer1 = false;
      this.showCustomer2 = false;
      this.showCustomer3 = false;
      this.showCustomer4 = false;
      this.showCustomer5 = false;
      this.showDisplayName = false;
      this.showAircraft = false;
      this.showInstructor = false;
      this.showDpe = false;
      // this.showRoom = false;
      // this.showHost = false;
      // this.showAttendees = false;
      this.showDayNightFlight = false;
      this.showFlightType = false;
      this.showFlightRules = false;
      this.showFlightRoute = false;
      this.showFlightTime = false;
      this.showComments = true;
      this.showInternalComments = true;
      // this.showNotifications = true;
      // this.showStandby = true;
      // this.showRecurring = true;
    },
    selectedActivity() {
      this.resetFields();

      if (!this.isEditMode) {
        this.formData.tempDisplayName = "";
      }

      let selectedType = pullObjectInfo(
        this.eventTypes,
        this.formData.eventTypeId,
      );
      // const element = document.getElementById("activityIndicator");
      // element.style.backgroundColor = selectedType?.scheduledColor;

      switch (selectedType?.name) {
        case "Checkride Flight":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          this.showDpe = true;
          this.dpeRequired = true;
          break;
        case "Checkride Oral":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showDisplayName = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          this.showDpe = true;
          this.dpeRequired = true;
          break;
        case "Crew Flight":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showCustomer2 = true;
          this.customer2Required = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showDayNightFlight = true;
          this.dayNightFlightRequired = true;
          this.showFlightType = true;
          this.flightTypeRequired = true;
          this.showFlightRules = true;
          this.flightRulesRequired = true;
          this.showFlightRoute = true;
          break;
        case "Discovery Flight":
          this.showCustomer1 = true;
          this.showDisplayName = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          break;
        case "Dual Flight Training":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.displayNameRequired = "";
          this.showDisplayName = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          this.showDayNightFlight = true;
          this.dayNightFlightRequired = true;
          break;
        case "Frasca Sim":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          break;
        case "Ground Training":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showCustomer2 = true;
          this.showCustomer3 = true;
          this.showCustomer4 = true;
          this.showCustomer5 = true;
          this.showDisplayName = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          break;
        case "Interview Flight":
          this.showDisplayName = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          break;
        case "Interview Oral":
          this.showDisplayName = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          break;
        case "Maintenance":
          this.showAircraft = true;
          // this.showRecurring = false;
          // this.showNotifications = false;
          // this.showStandby = false;
          this.formData.tempDisplayName = "Maintenance";
          if (!this.event) {
            this.formData.startDateTime = dayjs().format("YYYY-MM-DDTHH:mm");
            this.formData.endDateTime = dayjs()
              .add(4, "weeks")
              .format("YYYY-MM-DDTHH:mm");
          }
          break;
        case "Potential Student":
          this.showDisplayName = true;
          this.showInstructor = true;
          this.instructorRequired = true;
          break;
        case "Renter/Member Flight":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showCustomer2 = true;
          this.showDisplayName = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          this.showDayNightFlight = true;
          this.dayNightFlightRequired = true;
          this.showFlightType = true;
          this.flightTypeRequired = true;
          this.showFlightRules = true;
          this.flightRulesRequired = true;
          this.showFlightRoute = true;
          this.showFlightTime = true;
          break;
        case "Student Solo":
          this.showCustomer1 = true;
          this.customer1Required = true;
          this.showDisplayName = true;
          this.showAircraft = true;
          this.aircraftRequired = true;
          this.showInstructor = true;
          this.showDayNightFlight = true;
          this.dayNightFlightRequired = true;
          this.showFlightType = true;
          this.flightTypeRequired = true;
          this.showFlightRules = true;
          this.flightRulesRequired = true;
          this.showFlightTime = true;
          this.flightTimeRequired = true;
          this.showFlightRoute = true;
          this.flightRouteRequired = true;
          break;
        case "Time Off":
          this.formData.tempDisplayName = "Unavailable";
          this.showInstructor = true;
          this.instructorRequired = true;
          // this.showRecurring = false;
          this.showComments = false;
          this.showInternalComments = false;
          // this.showNotifications = false;
          // this.showStandby = false;
          break;
        // case "Class Meeting":
        //   this.showInstructor = true;
        //   this.instructorRequired = true;
        //   this.showRoom = true;
        //   this.roomRequired = true;
        //   this.showAttendees = true;
        //   // TODO Add lesson, remove display name when added
        //   this.showDisplayName = true;
        //   this.displayNameRequired = true;
        //   break;
        // case "Meeting":
        //   this.showDisplayName = true;
        //   this.displayNameRequired = true;
        //   this.showHost = true;
        //   this.showRoom = true;
        //   this.roomRequired = true;
        //   this.showAttendees = true;
        //
        //   // TODO Add host
        //   break;
      }
    },
    expandSection(section) {
      if (section === "comments") {
        this.expandComments = true;
      }
      if (section === "internalComments") {
        this.expandInternalComments = true;
      }
      // if (section === "notifications") {
      //   this.expandNotifications = true;
      // }
    },
    selectedRecurring() {
      //TODO
    },
    selectedStandby() {
      //TODO
    },
    async createEvent(newEvent, changelog) {
      try {
        const createEntry = {
          ...this.currentUser,
          action: "Create",
          changes: changelog,
        };
        let temp = {
          event: newEvent,
          history: createEntry,
        };
        const created = await eventsAPIService.create(temp, this.$router);
        created.startDateTime = dayjs(created.startDateTime)
          .local()
          .format("YYYY-MM-DDTHH:mm"); // #DATE Format to local before db response completes
        created.endDateTime = dayjs(created.endDateTime)
          .local()
          .format("YYYY-MM-DDTHH:mm"); // #DATE Format to local before db response completes
        this.toast(
          "b-toaster-bottom-right",
          `Successfully created event \"${created.displayName}\"!`,
          "success",
          true,
        );
        this.$emit("event-created", created);
      } catch (error) {}
    },
    async updateEvent(updatedEvent, changelog) {
      try {
        const updateEntry = {
          ...this.currentUser,
          action: "Update",
          changes: changelog,
        };
        let temp = {
          event: updatedEvent,
          history: updateEntry,
        };
        const updated = await eventsAPIService.update(
          updatedEvent.id,
          temp,
          this.$router,
        );
        updated.startDateTime = dayjs(updated.startDateTime)
          .local()
          .format("YYYY-MM-DDTHH:mm"); // #DATE Format to local before db response completes
        updated.endDateTime = dayjs(updated.endDateTime)
          .local()
          .format("YYYY-MM-DDTHH:mm"); // #DATE Format to local before db response completes
        this.toast(
          "b-toaster-bottom-right",
          `Successfully updated event \"${updated.displayName}\"!`,
          "success",
          true,
        );
        this.$emit("event-updated", updated);
      } catch (error) {}
    },
    async deleteEvent() {
      this.isDeleteEventModalVisible = true;
    },
    toast(toaster, message, variant, append = false) {
      this.$bvToast.toast(`${message}`, {
        title: `Success`,
        toaster: toaster,
        solid: true,
        variant: variant,
        appendToast: append,
        autoHideDelay: 2000,
      });
    },
    validateForm() {
      const missingFields = [];

      if (!this.formData.eventTypeId) {
        missingFields.push("Activity Type");
      }
      if (!this.formData.startDateTime) {
        missingFields.push("Event Start");
      }
      if (!this.formData.endDateTime) {
        missingFields.push("Event End");
      }
      if (
        this.formData.startDateTime &&
        this.formData.endDateTime &&
        dayjs(this.formData.startDateTime).isAfter(
          dayjs(this.formData.endDateTime),
        )
      ) {
        missingFields.push("End Date must be after Start Date");
      }
      if (
        (this.customer1Required && !this.formData.customer1Id) ||
        this.customerHasFlightHold(this.formData.customer1Id)
      ) {
        missingFields.push("Customer 1");
      }
      if (
        (this.customer2Required && !this.formData.customer2Id) ||
        this.customerHasFlightHold(this.formData.customer2Id)
      ) {
        missingFields.push("Customer 2");
      }
      if (
        (this.aircraftRequired && !this.formData.aircraftId) ||
        this.planeMaintenance
      ) {
        missingFields.push("Aircraft");
      }
      if (this.instructorRequired && !this.formData.instructorId) {
        missingFields.push("Instructor");
      }
      if (this.dpeRequired && !this.formData.dpeId) {
        missingFields.push("DPE");
      }
      // if (this.roomRequired && !this.formData.roomId) {
      //   missingFields.push("Room");
      // }
      // if (
      //   this.attendeesRequired &&
      //   (!this.formData.attendees || !this.formData.attendees.length)
      // ) {
      //   missingFields.push("Attendees");
      // }
      if (this.dayNightFlightRequired && !this.formData.dayNightFlight) {
        missingFields.push("Day/Night Flight");
      }
      if (this.flightTypeRequired && !this.formData.flightType) {
        missingFields.push("Flight Type");
      }
      if (this.flightRulesRequired && !this.formData.flightRules) {
        missingFields.push("Flight Rules");
      }
      if (this.flightTimeRequired && !this.formData.flightTime) {
        missingFields.push("Flight Time");
      }
      if (this.flightRouteRequired && !this.formData.flightRoute) {
        missingFields.push("Flight Route");
      }

      return missingFields;
    },
    handleSubmit() {
      const missingFields = this.validateForm();

      if (missingFields.length) {
        alert(
          `The following fields are required or invalid:\n\n${missingFields.join("\n")}`,
        );
        return;
      }

      const newEvent = {
        ...this.formData,
        displayName: this.formData.tempDisplayName
          ? this.formData.tempDisplayName
          : `${dayjs(this.formData.startDateTime).format("HH:mm")} ${pullObjectInfo(this.customers, this.formData.customer1Id).name}`,
        eventStatusId: 1,
      };
      let changelog;
      if (this.isEditMode) {
        // UPDATING AN EVENT
        changelog = generateChangelog(this.pastEvent, newEvent, {
          eventTypes: this.eventTypes,
          aircraft: this.aircraft,
          instructors: this.instructors,
          dpes: this.dpes,
          customers: this.customers,
        });
        newEvent.id = this.formData.id;
        newEvent.startDateTime = dayjs(newEvent.startDateTime).utc().format(); // #DATE Format UTC before push to DB
        newEvent.endDateTime = dayjs(newEvent.endDateTime).utc().format(); // #DATE Format UTC before push to DB
        this.updateEvent(newEvent, changelog);
      } else {
        // NEW EVENT
        changelog = generateChangelog(null, newEvent, {
          eventTypes: this.eventTypes,
          aircraft: this.aircraft,
          instructors: this.instructors,
          dpes: this.dpes,
          customers: this.customers,
        });
        newEvent.startDateTime = dayjs(newEvent.startDateTime).utc().format(); // #DATE Format UTC before push to DB
        newEvent.endDateTime = dayjs(newEvent.endDateTime).utc().format(); // #DATE Format UTC before push to DB
        this.createEvent(newEvent, changelog);
      }
    },
    async confirmDeleteEvent() {
      const deleted = this.event;
      try {
        await eventsAPIService.delete(deleted.id, deleted, this.$router);
        this.toast(
          "b-toaster-bottom-right",
          `Successfully deleted event \"${deleted.displayName}\"!`,
          "success",
          true,
        );
        this.$emit("event-deleted", deleted);
      } catch (error) {}
    },
    closeDeleteModal() {
      this.isDeleteEventModalVisible = false;
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style module scoped>
.reservation {
  position: relative;
  font-size: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.leftLabel {
  width: 180px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.chooseOneParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.radioGroupParent {
  flex: 1;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  box-sizing: border-box;
}
.textAreaParent {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}
.selectionContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.dateParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.datetimeInput {
  flex-grow: 1;
  height: 30px;
  border: none;
  background-color: transparent;
  font-size: 15px;
  color: black;
  padding: 0 10px;
  border-radius: 5px;
  outline: none;
}
.inputStyle {
  flex-grow: 1;
  height: 30px;
  border: none;
  background-color: transparent;
  font-size: 15px;
  color: black;
  padding: 0 13px;
  border-radius: 5px;
  outline: none;
}
.inputStyle::placeholder {
  color: #9b9b9b;
}
/*noinspection CssUnusedSymbol */
.placeholder-active {
  color: #9b9b9b;
}
.dateContainer {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
  height: 100%;
  padding-right: 10px;
  overflow-y: auto;
}
.continueWrapper {
  align-self: stretch;
  border: none;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  z-index: 2;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.vectorIcon9 {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.reservationPopup {
  width: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin: auto;
  max-height: 90vh;
  height: 90vh;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
.redError {
  color: red;
}
.orangeWarning {
  color: #eba134;
}
/*
.switchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
*/
/*noinspection CssUnusedSymbol */
.el-switch {
  margin-left: auto;
}
/*noinspection CssUnusedSymbol */
.el-switch__core {
  border-radius: 50px;
}
input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
</style>
